import { Component, OnInit } from '@angular/core';
import {GeliosFieldBaseComponent} from '../gelios-field-base/gelios-field-base.component';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-gelios-hidden-field',
  templateUrl: './gelios-hidden-field.component.html',
})
export class GeliosHiddenFieldComponent extends GeliosFieldBaseComponent implements OnInit {
  constructor(
    protected translate: TranslateService
  ) {
    super(translate);
  }
}
